import { render, staticRenderFns } from "./StaticBanner.vue?vue&type=template&id=04914650&scoped=true"
import script from "./StaticBanner.vue?vue&type=script&lang=ts"
export * from "./StaticBanner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04914650",
  null
  
)

export default component.exports